import { Col, ColProps } from 'antd';
import { FC } from 'react';
const ThreeItemColumn: FC<ColProps> = (props) => {
  // console.log(props);
  return (
    <Col
      className="policy-list-wrap"
      xs={{ span: 23, offset: 0 }}
      sm={{ span: 23, offset: 0 }}
      md={{ span: 12, offset: 0 }}
      lg={{ span: 8, offset: 0 }}
      {...props}
    />
  );
};

export default ThreeItemColumn;
